import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "custom-fields",
    title: "ฟิลด์เพิ่มเติม",
    summary:
      "เพิ่มช่องข้อมูลของผู้ใช้ที่องค์กรต้องการนอกเหนือจากช่องมาตรฐาน (เช่น สาขา ระดับพนักงาน วันเริ่มงาน) ฟิลด์ที่สร้างจะแสดงในหน้ารายละเอียดผู้ใช้ แสดงในหน้าสมัครสมาชิกได้ และส่งให้แอปใน token ได้",
    access:
      "เปิดดูได้เมื่อมีสิทธิ์ settings:read (owner, admin, auditor) · เพิ่ม แก้ไข เรียงลำดับ ลบ และบันทึกได้เมื่อมีสิทธิ์ settings:write (owner, admin) · การกรอกค่าของฟิลด์ให้ผู้ใช้แต่ละคนทำที่หน้ารายละเอียดผู้ใช้ (ต้องมีสิทธิ์ users:write)",
    shot: { file: "custom-fields-list.png", caption: "หน้าฟิลด์เพิ่มเติมที่มีฟิลด์ 3 รายการ" },
    sections: [
      {
        id: "where",
        heading: "ฟิลด์เพิ่มเติมแสดงที่ไหนบ้าง",
        body: [
          'หน้ารายละเอียดผู้ใช้ → แท็บ โปรไฟล์ → หัวข้อ "ฟิลด์เพิ่มเติม": ทุกฟิลด์แสดงตามลำดับในหน้านี้ ผู้ดูแลกรอกหรือแก้ค่าได้ ชื่อฟิลด์แสดงตามภาษาของคอนโซล (ชื่อไทยหรือชื่ออังกฤษ)',
          'หน้าสมัครสมาชิก: เฉพาะฟิลด์ที่เลือก "แสดงในหน้าสมัครสมาชิก" ผู้สมัครกรอกเองตอนสมัคร',
          'Token ที่ส่งให้แอป: เฉพาะฟิลด์ที่เลือก "ส่งใน token claims (scope employee)" และแอปต้องขอ scope employee โดยใช้คีย์ของฟิลด์เป็นชื่อข้อมูล (ฟิลด์ที่ไม่มีค่าจะไม่ถูกส่ง)',
        ],
      },
      {
        id: "list",
        heading: "ตารางฟิลด์",
        body: [
          'แถบด้านบนมีปุ่ม "โหลดใหม่" "เพิ่มฟิลด์" และ "บันทึกฟิลด์" ถ้ายังไม่มีฟิลด์ จะเห็นข้อความ "ยังไม่มีฟิลด์เพิ่มเติม — เพิ่มเพื่อขยายข้อมูลพนักงาน"',
        ],
        fieldsTitle: "คอลัมน์และปุ่มในตาราง",
        fields: [
          { name: "คีย์", description: "ชื่อฟิลด์ตามภาษาของคอนโซล และคีย์ของฟิลด์ตัวเล็กด้านล่าง" },
          { name: "ชนิด", description: "ข้อความ, ตัวเลข, ใช่/ไม่ใช่, วันที่ หรือ ตัวเลือก" },
          {
            name: "ป้าย",
            description: '"บังคับกรอก" (สีส้ม), "แสดงในหน้าสมัครสมาชิก" และ "claims" (สีฟ้า = ส่งใน token)',
          },
          {
            name: "ปุ่มลูกศรขึ้น/ลง",
            description:
              '"เลื่อนขึ้น" / "เลื่อนลง" เปลี่ยนลำดับการแสดงในหน้าผู้ใช้และหน้าสมัครสมาชิก (แถวแรกเลื่อนขึ้นไม่ได้ แถวสุดท้ายเลื่อนลงไม่ได้)',
          },
          { name: "ปุ่มดินสอ", description: '"แก้ไข" เปิดหน้าต่างแก้ไขฟิลด์' },
          { name: "ปุ่มถังขยะ", description: '"ลบ" เอาฟิลด์ออกจากรายการ (ไม่มีหน้าต่างยืนยัน)' },
        ],
        warnings: [
          'ทุกการเปลี่ยนแปลงในหน้านี้ (เพิ่ม แก้ไข เรียงลำดับ ลบ) เป็นแค่ฉบับร่าง จนกว่าจะกด "บันทึกฟิลด์" ปุ่มนี้จะกดได้เมื่อมีการเปลี่ยนแปลงที่ยังไม่บันทึก ถ้าออกจากหน้าหรือกด "โหลดใหม่" ก่อนบันทึก การเปลี่ยนแปลงจะหายไป',
        ],
        tips: ['ถ้าลบหรือย้ายผิด ให้กด "โหลดใหม่" ก่อนกด "บันทึกฟิลด์" เพื่อกลับไปเป็นค่าที่บันทึกไว้ล่าสุด'],
      },
      {
        id: "editor",
        heading: "เพิ่มหรือแก้ไขฟิลด์",
        shot: { file: "custom-fields-editor-dialog.png", caption: "หน้าต่างเพิ่มฟิลด์ชนิดตัวเลือก" },
        fieldsTitle: "ช่องในหน้าต่าง",
        fields: [
          {
            name: "คีย์",
            required: true,
            description:
              "ชื่อภายในของฟิลด์ 2–41 ตัวอักษร ขึ้นต้นด้วยตัวพิมพ์เล็ก ตามด้วยตัวอักษรอังกฤษ ตัวเลข หรือ _ (ไม่มีขีด - และช่องว่าง) เช่น branch, startDate, staff_level ต้องไม่ซ้ำกับฟิลด์อื่น และ แก้ไม่ได้หลังสร้าง",
          },
          {
            name: "ชื่อ (ไทย)",
            required: true,
            description: "ชื่อที่แสดงเมื่อใช้ภาษาไทย ไม่เกิน 100 ตัวอักษร",
          },
          {
            name: "ชื่อ (อังกฤษ)",
            required: true,
            description: "ชื่อที่แสดงเมื่อใช้ภาษาอังกฤษ ไม่เกิน 100 ตัวอักษร",
          },
          {
            name: "ชนิด",
            description:
              "ข้อความ = พิมพ์อิสระ · ตัวเลข = ตัวเลขเท่านั้น · ใช่/ไม่ใช่ = ช่องติ๊ก · วันที่ = เลือกวันที่ · ตัวเลือก = เลือกหนึ่งค่าจากรายการที่กำหนด",
          },
          {
            name: "ตัวเลือก (บรรทัดละหนึ่งค่า)",
            required: true,
            description:
              'แสดงเฉพาะชนิด "ตัวเลือก" พิมพ์ค่าที่เลือกได้บรรทัดละค่า เช่น กรุงเทพ / เชียงใหม่ / ขอนแก่น (บรรทัดว่างถูกตัดทิ้ง ค่าละไม่เกิน 100 ตัวอักษร สูงสุด 100 ค่า)',
          },
          {
            name: "บังคับกรอก",
            description:
              "ผู้สมัครต้องกรอกฟิลด์นี้ในหน้าสมัครสมาชิก (ถ้าแสดงในหน้าสมัคร) และในหน้าผู้ใช้จะมีเครื่องหมายช่องบังคับ ผู้ใช้เดิมที่ยังไม่มีค่าไม่ถูกบล็อก",
          },
          {
            name: "แสดงในหน้าสมัครสมาชิก",
            description: "ให้ฟิลด์นี้แสดงในฟอร์มสมัครสมาชิก ระบบตรวจค่าก่อนสร้างบัญชี",
          },
          {
            name: "ส่งใน token claims (scope employee)",
            description: "ส่งค่าของฟิลด์ให้แอปที่ขอ scope employee",
          },
        ],
        steps: [
          'กด "เพิ่มฟิลด์" (หรือกดปุ่มดินสอของฟิลด์ที่ต้องการแก้)',
          "กรอกคีย์ ชื่อไทย ชื่ออังกฤษ เลือกชนิด (ถ้าเป็นตัวเลือก ให้กรอกตัวเลือก) และติ๊กตัวเลือกที่ต้องการ",
          'กด "บันทึก" ในหน้าต่าง (ปุ่มกดได้เมื่อกรอกครบและคีย์ถูกรูปแบบ) — ฟิลด์จะปรากฏในตาราง แต่ยังไม่ถูกบันทึกจริง',
          'กด "บันทึกฟิลด์" ที่แถบด้านบน — ระบบแสดง "บันทึกแล้ว"',
        ],
        tips: [
          "สร้างได้สูงสุด 50 ฟิลด์",
          "ไม่ควรตั้งคีย์ซ้ำกับชื่อข้อมูลมาตรฐานของ token (เช่น sub, email, name) ฟิลด์แบบนั้นจะไม่ถูกส่งใน token",
        ],
      },
      {
        id: "order",
        heading: "เรียงลำดับฟิลด์",
        steps: ["กดลูกศรขึ้น/ลงในแถวของฟิลด์จนได้ลำดับที่ต้องการ", 'กด "บันทึกฟิลด์"'],
      },
      {
        id: "delete",
        heading: "ลบฟิลด์",
        steps: ["กดปุ่มถังขยะในแถวของฟิลด์ — แถวหายจากตารางทันที", 'กด "บันทึกฟิลด์" เพื่อยืนยันการลบ'],
        warnings: [
          "หลังบันทึก ฟิลด์จะหายจากหน้าผู้ใช้ หน้าสมัครสมาชิก และ token ทันที แอปที่อ่านค่าฟิลด์นี้จาก token จะไม่ได้รับค่าอีก",
          "ค่าที่ผู้ใช้เคยกรอกไว้ยังถูกเก็บอยู่แต่จะไม่แสดง ถ้าสร้างฟิลด์ใหม่ด้วยคีย์เดิม ค่าเดิมจะกลับมาแสดง",
          "การเปลี่ยนชนิดหรือรายการตัวเลือกของฟิลด์ที่มีข้อมูลอยู่แล้ว ไม่ได้แปลงค่าเดิม ค่าเดิมที่ไม่ตรงกับชนิดหรือตัวเลือกใหม่อาจทำให้แก้ไขโปรไฟล์ไม่ผ่านจนกว่าจะแก้ค่านั้น",
        ],
      },
      {
        id: "conflict",
        heading: "เมื่อมีผู้ดูแลคนอื่นแก้พร้อมกัน",
        body: [
          'ถ้ามีคนบันทึกฟิลด์ไปก่อนคุณ ระบบจะไม่เขียนทับ แต่แสดงข้อความ "การตั้งค่าถูกแก้ไขโดยผู้อื่นแล้ว — โหลดใหม่เพื่อดูเวอร์ชันล่าสุด" ให้กด "โหลดใหม่" แล้วทำการแก้ไขซ้ำ',
        ],
      },
    ],
    related: ["user-detail", "users", "sign-in-method", "client-detail"],
  },
  en: {
    id: "custom-fields",
    title: "Custom fields",
    summary:
      "Add user profile fields your organisation needs beyond the standard ones (e.g. branch, staff level, start date). Custom fields appear on the user's page, can appear on the sign-up form and can be sent to applications in tokens.",
    access:
      "Viewing needs settings:read (owner, admin, auditor). Adding, editing, reordering, deleting and saving needs settings:write (owner, admin). Filling in the values for a particular user is done on the user's page (needs users:write).",
    shot: { file: "custom-fields-list.png", caption: "The Custom fields page with three fields" },
    sections: [
      {
        id: "where",
        heading: "Where custom fields appear",
        body: [
          'User page → Profile tab → "Custom fields" heading: every field, in the order set here. Admins can fill in or change the values. Field names follow the console language (Thai or English label).',
          'The sign-up form: only fields with "Show on sign-up"; visitors fill them in when signing up.',
          'Tokens sent to applications: only fields with "Include in token claims (employee scope)", and only when the application asks for the employee scope. The field key is used as the claim name (empty fields are not sent).',
        ],
      },
      {
        id: "list",
        heading: "The fields table",
        body: [
          'The bar at the top has "Reload", "Add field" and "Save fields". With no fields you see "No custom fields yet — add one to extend employee profiles".',
        ],
        fieldsTitle: "Columns and buttons in the table",
        fields: [
          {
            name: "Key",
            description:
              "The field name in the console language, with the field key in small text underneath.",
          },
          { name: "Type", description: "Text, Number, Yes/No, Date or Select." },
          {
            name: "Badges",
            description: '"Required" (orange), "Show on sign-up" and "claims" (blue = sent in tokens).',
          },
          {
            name: "Up/down arrows",
            description:
              '"Move up" / "Move down" change the order on the user page and the sign-up form (the first row cannot move up, the last cannot move down).',
          },
          { name: "Pencil button", description: '"Edit" opens the field editor.' },
          { name: "Bin button", description: '"Delete" removes the field from the list (no confirmation).' },
        ],
        warnings: [
          'Every change on this page (add, edit, reorder, delete) is only a draft until you click "Save fields". The button is enabled when there are unsaved changes. Leaving the page or clicking "Reload" before saving discards them.',
        ],
        tips: [
          'Deleted or moved something by mistake? Click "Reload" before "Save fields" to go back to the last saved version.',
        ],
      },
      {
        id: "editor",
        heading: "Add or edit a field",
        shot: { file: "custom-fields-editor-dialog.png", caption: "The Add field window for a Select field" },
        fieldsTitle: "Fields in the window",
        fields: [
          {
            name: "Key",
            required: true,
            description:
              "The field's internal name: 2–41 characters, a lowercase letter first, then English letters, digits or _ (no hyphens or spaces), e.g. branch, startDate, staff_level. Must be unique and cannot be changed after creation.",
          },
          { name: "Label (Thai)", required: true, description: "Name shown in Thai, up to 100 characters." },
          {
            name: "Label (English)",
            required: true,
            description: "Name shown in English, up to 100 characters.",
          },
          {
            name: "Type",
            description:
              "Text = free text · Number = numbers only · Yes/No = a checkbox · Date = a date picker · Select = one value from a fixed list.",
          },
          {
            name: "Options (one per line)",
            required: true,
            description:
              "Only for Select. One allowed value per line, e.g. Bangkok / Chiang Mai / Khon Kaen (blank lines are dropped; up to 100 characters each, up to 100 options).",
          },
          {
            name: "Required",
            description:
              "Visitors must fill the field on the sign-up form (when it is shown there), and the user page marks it as required. Existing users without a value are not blocked.",
          },
          {
            name: "Show on sign-up",
            description:
              "Shows the field on the sign-up form; the value is checked before the account is created.",
          },
          {
            name: "Include in token claims (employee scope)",
            description: "Sends the value to applications that ask for the employee scope.",
          },
        ],
        steps: [
          'Click "Add field" (or the pencil button of the field to change).',
          "Enter the key, Thai and English labels, choose the type (for Select, enter the options) and tick the options you need.",
          'Click "Save" in the window (enabled once everything required is filled and the key is valid) — the field appears in the table but is not stored yet.',
          'Click "Save fields" in the top bar — "Saved" appears.',
        ],
        tips: [
          "Up to 50 fields.",
          "Avoid keys that are standard token claim names (such as sub, email, name); such fields are never sent in tokens.",
        ],
      },
      {
        id: "order",
        heading: "Reorder fields",
        steps: ["Use the up/down arrows in the rows until the order is right.", 'Click "Save fields".'],
      },
      {
        id: "delete",
        heading: "Delete a field",
        steps: [
          "Click the bin button in the field's row — the row disappears at once.",
          'Click "Save fields" to confirm the deletion.',
        ],
        warnings: [
          "After saving, the field disappears from user pages, the sign-up form and tokens immediately. Applications reading it from tokens stop receiving it.",
          "Values users already have are kept but hidden. Creating a field with the same key again shows them again.",
          "Changing the type or options of a field that already has data does not convert existing values. Old values that no longer fit may block saving that user's profile until the value is corrected.",
        ],
      },
      {
        id: "conflict",
        heading: "When another admin edits at the same time",
        body: [
          'If someone saved the fields after you opened the page, your save does not overwrite theirs. You see "Settings were changed by someone else — reload to see the latest version." Click "Reload" and make your change again.',
        ],
      },
    ],
    related: ["user-detail", "users", "sign-in-method", "client-detail"],
  },
};

export default topic;
